<template>
  <tooltip-hover
    class="tw-w-fit tw-inline-block"
    fixed
    :class="$attrs.class"
    :text="`${prefix ? `${prefix} ` : ''}${formattedTimestamp}`"
  >
    <slot />
  </tooltip-hover>
</template>
<script>
import TooltipHover from '@components/Message/TooltipHover.vue'
import { computed, toRefs } from 'vue'
import { DateTime } from 'luxon'

export default {
  components: {
    TooltipHover,
  },
  inheritAttrs: false,
  props: {
    timestamp: {
      type: [String, Number, Date],
      required: true,
    },
    prefix: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { timestamp } = toRefs(props)
    const formattedTimestamp = computed(() => {
      if (!timestamp.value) return ''

      let result = null

      switch (typeof timestamp.value) {
        case 'number':
          result =
            timestamp.value > 1e10
              ? // milliseconds
                DateTime.fromMillis(timestamp.value)
              : // seconds
                DateTime.fromSeconds(timestamp.value)
          break
        case 'string':
          result = DateTime.fromISO(timestamp.value)
          break
        case 'object':
          result = DateTime.fromJSDate(timestamp.value)
          break
      }

      return result && result.isValid
        ? result.toLocaleString({
            ...DateTime.DATE_FULL,
            hour: 'numeric',
            minute: '2-digit',
            hourCycle: 'h12',
          })
        : ''
    })

    return {
      formattedTimestamp,
    }
  },
}
</script>
